import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Container } from '../../locations/BulkEdit/EditInformations/styles'
import styled from 'styled-components'
import useAxios from 'axios-hooks'
import { toast } from 'react-toastify'
import { LoadableCard } from '~/components/commons'
import Textarea from '~/components/Textarea'
import { useSelector } from 'react-redux'

const WHATSAPP_MESSAGE_MAX_LENGTH = 200

const EditVariablesForm = () => {
  const intl = useIntl()
  const [whatsappMessage, setWhatsappMessage] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(true)
  const [isDisabled, setIsDisabled] = React.useState(false)
  const accountId = useSelector(state => state.user?.profile?.account?.id)

  const [{ data }] = useAxios({
    url: `/accounts/${accountId}/variables`,
    method: 'GET',
  })

  const [, updateAccountVariables] = useAxios(
    {
      url: `/accounts/${accountId}/variables/whatsapp-message`,
      method: 'POST',
    },
    {
      manual: true,
    }
  )

  function handleChange(e) {
    const value = e.target.value

    setIsDisabled(value.length > WHATSAPP_MESSAGE_MAX_LENGTH)
    setWhatsappMessage(e.target.value)
  }

  async function handleSubmit(e) {
    setIsLoading(true)
    e.preventDefault()

    try {
      await updateAccountVariables({
        data: {
          whatsappMessage: whatsappMessage,
        },
      })
      toast.success(
        intl.formatMessage({ id: 'Variables updated successfully' })
      )
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'Error while updating variables' }))
    }
    setIsLoading(false)
  }

  React.useEffect(() => {
    if (!data) return

    setIsLoading(false)

    setWhatsappMessage(data?.whatsappMessage || '')
  }, [data])

  return (
    <LoadableCard className="p-3" loading={isLoading}>
      <Container>
        <StyledForm>
          <h2>
            <FormattedMessage id="Whatsapp Redirect Message" />
          </h2>
          <label>
            <FormattedMessage id="Message:" />
          </label>
          <Textarea
            className="form-control"
            value={whatsappMessage}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: 'Hi, I found Brand on Google and would like to be attended.',
            })}
            maxLength={WHATSAPP_MESSAGE_MAX_LENGTH}
          />

          <button onClick={handleSubmit} disabled={isLoading || isDisabled}>
            <FormattedMessage id="Save Changes" />
          </button>
        </StyledForm>
      </Container>
    </LoadableCard>
  )
}

const StyledForm = styled.div`
  h2 {
    color: #2c2c2c;
    font-family: Montserrat;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    margin-bottom: 1.5rem;
  }

  button {
    width: fit-content;
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background-color: #61c478;
    border-radius: 0.4rem;
    border: none;
    color: white;

    &:disabled {
      opacity: 0.65;
    }
  }
`

export default EditVariablesForm
